import { StyleProp, ViewStyle } from 'react-native'
import Animated from 'react-native-reanimated'
import cn from '@ui/utils/cn'

interface Props {
  className?: string
  style?: StyleProp<ViewStyle>
}

export default function Border({ className, style = {} }: Props) {
  return (
    <Animated.View
      className={cn(
        'pointer-events-none absolute h-full w-full rounded-2xl border border-black/10',
        className
      )}
      style={style}
    />
  )
}
